import contentRequest from '~/src/api/requests/contentRequest';

export const tvBoxRequest = async(domain, tvBoxId, leasingDuration, leasing, initialData) => {
    const tvBox = await contentRequest.getWithCache(`${domain}/v1/decoder`)
        .then(request => request.data.items.find(item => item.materials_ens_id === Number(tvBoxId)))
        .catch(() => {});

    if (!tvBox) {
 return;
}

    // в заявке приставка в рассрочку, т.к. leasing == 1 и есть leasingDuration - срок рассрочки
    if (leasing && leasingDuration) {
        const price = Number(leasingDuration) === tvBox.leasing_dur ? tvBox.leasing_mon_price : tvBox.leasing_mon_price_two;
        initialData.monthly.list.push({
            name: tvBox.mat_name + ` (Рассрочка на ${leasingDuration} мес.)`,
            period: 'в мес.',
            price,
            formData: [
                {
                    key: 'tvBoxId',
                    value: tvBoxId
                },
                {
                    key: 'leasingDuration',
                    value: leasingDuration
                },
                {
                    key: 'materials_ens_id',
                    value: tvBox.materials_ens_id
                }
            ]
        });
        initialData.monthly.total = Number(initialData.monthly.total) + Number(price);
    }

    // в заявке приставка полную цену, т.к. leasing == 0
    if (!leasing) {
        const price = tvBox.posess_price;
        initialData.once.list.push({
            name: tvBox.mat_name,
            price,
            formData: [
                {
                    key: 'tvBoxId',
                    value: tvBoxId
                },
                {
                    key: 'materials_ens_id',
                    value: tvBox.materials_ens_id
                }
            ]
        });
        initialData.once.total = Number(initialData.once.total) + Number(price);
    }
};

export const addTvBoxInCheckPosess = (tvBox, currentCheck, deleteEquipment) => {

    const augmentedCheck = { ...currentCheck };

    augmentedCheck.once.list.push({
        materialsEnsId: tvBox.materials_ens_id,
        name: tvBox.mat_name,
        price: tvBox.posess_price,
        formData: [
            {
                key: 'tvBoxId',
                value: tvBox.materials_ens_id
            },
            {
                key: 'materials_ens_id',
                value: tvBox.materials_ens_id
            }
        ],
        deleteItem: () => deleteEquipment(tvBox.materials_ens_id)
    });
    augmentedCheck.once.total = Number(augmentedCheck.once.total) + Number(tvBox.posess_price);

    return augmentedCheck;
};

export const addTvBoxInCheckLeasing = (tvBox, leasingOption, currentCheck, deleteEquipment) => {

    const augmentedCheck = { ...currentCheck };
    const leasingDuration = Number(leasingOption.duration);
    const price = Number(leasingOption.price);

    augmentedCheck.monthly.list.push({
        materialsEnsId: tvBox.materials_ens_id,
        name: tvBox.mat_name + ` (Рассрочка на ${leasingDuration} мес.)`,
        period: 'в мес.',
        price,
        formData: [
            {
                key: 'tvBoxId',
                value: tvBox.materials_ens_id
            },
            {
                key: 'leasingDuration',
                value: leasingDuration
            },
            {
                key: 'materials_ens_id',
                value: tvBox.materials_ens_id
            }
        ],
        deleteItem: () => deleteEquipment(tvBox.materials_ens_id)
    });
    augmentedCheck.monthly.total = Number(augmentedCheck.monthly.total) + Number(price);

    return augmentedCheck;
};
